import { useCallback, useState } from 'react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import { IConfirmDialog, IConfirmDialogButtonProps } from './interfaces'

import styles from './ConfirmDialog.module.scss'

export const ConfirmDialog = <T = string,>(props: IConfirmDialog<T>) => {
  return (
    <ModalDialog
      show={props.show}
      onClose={props.onClose}
      size={'xs'}
      content={ConfirmDialogContent}
      contentProps={props}
    />
  )
}

export const ConfirmDialogContent = <T = string,>(props: IConfirmDialog<T>) => {
  const [loadingButtonKey, setLoadingButtonKey] = useState<T | null>(null)

  const renderButtons = useCallback(() => {
    const renderButton = (buttonProps: IConfirmDialogButtonProps<T>) => {
      return (
        <Button
          {...buttonProps}
          __testId={`confirm-dialog-button-${buttonProps.title}`}
          key={`${buttonProps.key}`}
          disabled={loadingButtonKey ? loadingButtonKey !== buttonProps.key : false}
          loading={loadingButtonKey === buttonProps.key}
          onClick={async () => {
            setLoadingButtonKey(buttonProps.key)
            await props.onAction(buttonProps.key)
            setLoadingButtonKey(null)
            props.onClose()
          }}
        >
          {buttonProps.title}
        </Button>
      )
    }

    if (props.buttons) {
      return props.buttons.map((el) => renderButton(el))
    }
    if (props.textButton) {
      return renderButton({
        title: `${props.textButton}`,
        key: props.textButton,
      })
    }
    return null
  }, [loadingButtonKey, props])

  return (
    <div>
      {!props.hideTitle ? (
        <p className={styles.dialogConfirmTitle}>{props.textTitle || 'Confirm Action'}</p>
      ) : null}
      <p className={styles.dialogConfirmText}>{props.textQuestion}</p>
      <div className={styles.dialogButtons}>{renderButtons()}</div>
    </div>
  )
}
